/**
 * Window-event bridge into the globally mounted ``DeployModelConfirmGate``
 * (``HorizontalNavBar``). Every surface that can start a deployment awaits
 * ``confirmModelDeployment()`` before posting ``model-deployment``; on SaaS
 * with billing on the gate shows the "Deploy Model" note (input tokens are
 * billed per MTok) and resolves with the user's answer, everywhere else — and
 * whenever no gate is mounted — it resolves ``true`` at once.
 */
export const MODEL_DEPLOY_CONFIRM_EVENT = 'model-deploy:confirm';

export function confirmModelDeployment() {
    if (typeof window === 'undefined') return Promise.resolve(true);
    return new Promise((resolve) => {
        const detail = { handled: false, resolve };
        window.dispatchEvent(new CustomEvent(MODEL_DEPLOY_CONFIRM_EVENT, { detail }));
        // dispatchEvent is synchronous: an unmounted gate leaves ``handled`` false.
        if (!detail.handled) resolve(true);
    });
}
